import { render, staticRenderFns } from "./TransactionTable.vue?vue&type=template&id=31a98856&"
import script from "./TransactionTable.vue?vue&type=script&lang=js&"
export * from "./TransactionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/apple/Desktop/linebot-backend.hciot.com.tw/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31a98856')) {
      api.createRecord('31a98856', component.options)
    } else {
      api.reload('31a98856', component.options)
    }
    module.hot.accept("./TransactionTable.vue?vue&type=template&id=31a98856&", function () {
      api.rerender('31a98856', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/reserve_system_dashboard/components/TransactionTable.vue"
export default component.exports